export const toLegalEntityPayload = (values: any) => ({
  code: values.code,
  name: values.name,
  country: { id: values.country.value },
  isEnabled: true
})

export const toLegalEntityPatchPayload = (values: any) => ({
  name: values.name,
  isEnabled: values.isEnabled
})
